(() => {
  'use strict';
  const controllers = new WeakMap();
  function init() {
    document.querySelectorAll('[data-bunny-header]').forEach(header => {
      if (controllers.has(header)) return;
      const toggle = header.querySelector('[data-bunny-menu-toggle]');
      const panel = header.querySelector('[data-bunny-mobile-menu]');
      const close = panel?.querySelector('[data-bunny-menu-close]');
      if (!toggle || !panel || !close) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const query = matchMedia('(max-width: 899px)');
      const background = [...document.querySelectorAll('main, footer, [data-social-dock]')];
      const previousInert = new Map();
      let isOpen = false;
      function setOpen(open, restore = false) {
        if (open === isOpen) return;
        isOpen = open;
        toggle.setAttribute('aria-expanded', String(open));
        panel.setAttribute('aria-hidden', String(!open));
        panel.inert = !open;
        panel.classList.toggle('is-open', open);
        document.body.classList.toggle('bunny-menu-open', open);
        document.body.classList.toggle('is-locked', open);
        background.forEach(element => {
          if (open) { previousInert.set(element, element.inert); element.inert = true; }
          else { element.inert = previousInert.get(element) ?? false; }
        });
        if (open) close.focus();
        else { previousInert.clear(); if (restore) toggle.focus(); }
      }
      toggle.addEventListener('click', () => setOpen(!isOpen), options);
      close.addEventListener('click', () => setOpen(false, true), options);
      panel.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setOpen(false), options));
      panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false, true); }
        if (event.key !== 'Tab') return;
        const focusable = [...panel.querySelectorAll('a[href], button')];
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      query.addEventListener('change', () => { if (!query.matches) setOpen(false, true); }, options);
      window.addEventListener('pageshow', () => setOpen(false), options);
      controllers.set(header, () => { setOpen(false); controller.abort(); controllers.delete(header); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bunny-header]').forEach(header => controllers.get(header)?.());
  });
})();
